var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 1.00897C16.3036 1.61128 15.5324 2.07195 14.7164 2.37324C14.2784 1.75576 13.6962 1.3181 13.0488 1.11947C12.4013 0.920833 11.7196 0.970799 11.0961 1.26261C10.4725 1.55442 9.93705 2.07399 9.56217 2.75105C9.18729 3.42812 8.99105 4.23001 9 5.04827V5.93995C7.72192 5.98058 6.45547 5.63305 5.31346 4.92829C4.17145 4.22354 3.18932 3.18345 2.45455 1.90065C2.45455 1.90065 -0.454545 9.92575 6.09091 13.4925C4.59311 14.739 2.80884 15.364 1 15.2758C7.54545 19.7342 15.5455 15.2758 15.5455 5.02152C15.5448 4.77315 15.5253 4.52539 15.4873 4.28143C16.2295 3.38395 16.7533 2.25082 17 1.00897Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.4c3c7e5de676e78063d5d9f033b03f61.svg";
export { ForwardRef as ReactComponent };